// extracted by mini-css-extract-plugin
module.exports = {"section":"TaskFilesSection_section__K_Sz9","list":"TaskFilesSection_list__NxTkU","chip":"TaskFilesSection_chip__Bmcvt","name":"TaskFilesSection_name__rxdz1"};